import {
  getCountryList,
  getCountryUniversityList,
  updateInterestedCountries,
} from "@/store/feature/country/countryApi";
import { CountryState } from "@/store/types/countryTypes";

import { createSlice } from "@reduxjs/toolkit";

const initialState: CountryState = {
  countryList: [],
  countryListTotal: 0,
  universityList: [],
  universityListTotal: 0,
  universityFilterOptions: [],
  loading: false,
  updateLoading: false,
};

const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCountryList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCountryList.fulfilled, (state, action) => {
        state.loading = false;
        const list = Array.isArray(action.payload?.list)
          ? action.payload.list
          : Array.isArray(action.payload)
          ? action.payload
          : [];
        state.countryList = list;
        state.countryListTotal = action.payload?.total ?? list.length;
      })
      .addCase(getCountryList.rejected, (state) => {
        state.loading = false;
        state.countryList = [];
        state.countryListTotal = 0;
      })
      .addCase(getCountryUniversityList.pending, (state) => {
        state.loading = true;
        // state.universityList = [];
        // state.universityListTotal = 0;
      })
      .addCase(getCountryUniversityList.fulfilled, (state, action) => {
        state.loading = false;
        state.universityList = action.payload.list;
        state.universityListTotal = action.payload.total;
        state.universityFilterOptions = action.payload.all_course_level;
      })
      .addCase(getCountryUniversityList.rejected, (state) => {
        state.loading = false;
        state.universityList = [];
        state.universityListTotal = 0;
      })
      .addCase(updateInterestedCountries.pending, (state) => {
        state.updateLoading = true;
      })
      .addCase(updateInterestedCountries.fulfilled, (state) => {
        state.updateLoading = false;
      })
      .addCase(updateInterestedCountries.rejected, (state) => {
        state.updateLoading = false;
      });
  },
});

export const {} = countrySlice.actions;
export default countrySlice.reducer;
